exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#terminal[data-v-7fffe6a6]{padding-top:64px}.logo[data-v-7fffe6a6]{left:1rem}.balance[data-v-7fffe6a6],.logo[data-v-7fffe6a6]{position:absolute}.balance[data-v-7fffe6a6]{right:1rem}nav[data-v-7fffe6a6]{background-color:#fff}", ""]);

// exports
